// extracted by mini-css-extract-plugin
export default {"placeholderContainer":"omnibar-placeholder-module__placeholderContainer--qQycB","placeholderText":"omnibar-placeholder-module__placeholderText--EV9tL"};